import { FormPageText } from "./FormPage.text";
import { $t } from "../../utils/intl";

export const defineTitle = (statusCode: number, formTitle?: string | null): string => {
  if (statusCode === 404) {
    return $t(FormPageText.notFoundTitle);
  }

  if (statusCode === 401) {
    return $t(FormPageText.enterPasscodeTitle);
  }

  return formTitle ?? $t(FormPageText.defaultTitle);
};

export const isFooterVisible = (isLoading: boolean, displayBranding?: boolean): boolean => {
  if (isLoading) {
    return false;
  }

  return displayBranding ?? true;
};
